import { NgModule } from '@angular/core';
import {
  CrntButton,
  CrntButtonAlt,
  CrntCheckbox,
  CrntCheckboxGroup,
  CrntComponentLoader,
  CrntFormControl,
  CrntFormControlHelpText,
  CrntFormControlLabel,
  CrntFormControlLabelIndicator,
  CrntFormControlValidationMessage,
  CrntIcon,
  CrntIconButton,
  CrntIconButtonAlt,
  CrntRadio,
  CrntRadioGroup,
  CrntRouterLink,
  CrntSelect,
  CrntTestingModule,
  CrntTextInput,
  CrntVisuallyHidden,
} from '@essent/current-web-angular';

const items = [
  CrntButton,
  CrntButtonAlt,
  CrntCheckbox,
  CrntCheckboxGroup,
  CrntComponentLoader,
  CrntFormControl,
  CrntFormControlHelpText,
  CrntFormControlLabel,
  CrntFormControlLabelIndicator,
  CrntFormControlValidationMessage,
  CrntIcon,
  CrntIconButton,
  CrntIconButtonAlt,
  CrntRadio,
  CrntRadioGroup,
  CrntRouterLink,
  CrntSelect,
  CrntTestingModule,
  CrntTextInput,
  CrntVisuallyHidden,
];

@NgModule({
  imports: [items],
  exports: [items],
})
export class FehCrntDesignSystemModule {}
